/**
* @name: import-date-process
* @author: weiyong
* @date: 2024-01-17 21:09
* @description：import-date-process
* @update: 2024-01-17 21:09
*/
<template>
  <div class="import-date-process">
    <a-result v-if="showLoading" title="数据导入中，请等待!">
      <template #icon>
        <smile-twoTone/>
      </template>
    </a-result>

    <a-result status="success" v-else>
      <template #title>
         <span style="color: #171a1d;font-size: 18px;font-weight: 500;">数据导入完成，
           成功
            <span class="common-link">{{ closeDataCheck ? successNum : successCount }}</span>
            <span>条！</span>
            <span>失败</span>
            <span class="common-link" style="color:#F00;">{{ closeDataCheck ? failNum : errorCount }}</span>
            <span>条！</span>
         </span>
      </template>
    </a-result>
    <div
      v-if="(!closeDataCheck||errorFlag) || (errorCount>0||(errorList&&errorList.length>0))"
      style="padding: 0 12px 12px 12px;position: relative;top:-30px;border: 1px solid #eee;margin: 10px;padding:12px;">
      <div class="flex-div-bet w100b" v-if="!closeDataCheck||errorFlag">
        <div style="font-weight: 500;font-size: 16px;">错误信息：</div>
        <div style="color:red" v-if="errorFlag">{{errorMsg}}</div>
        <div v-if="!errorFlag" @click.stop="downErrorTemp" class="common-link common-label" style="padding-right: 6px;">错误信息下载</div>
      </div>
      <import-result-show style="height: 150px;overflow: auto;" v-if="errorCount>0||(errorList&&errorList.length>0)" :records="errorList||errorRecords"/>
    </div>

    <div class="flex-div"
         style="margin-top: 0px;justify-content: flex-end;padding: 12px;position: absolute;right:20px;bottom:10px;">
      <a-button type="primary" @click.stop="closeWin">关闭</a-button>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "import-date-process",
});
</script>

<script lang="ts" setup>
import {Result as AResult, Steps as ASteps, Step as AStep} from 'ant-design-vue';
import ImportResultShow from "@/main-page/components/import-result-show.vue";
import {SmileTwoTone} from "@ant-design/icons-vue";
import {QueryCommand} from "xmgoing-server";

const emits = defineEmits(['closeWin'])

interface propsType {
  errorMsg:string;
  errorList:any,
  errorFlag:boolean;
  errorDownAction: string;
  closeDataCheck: boolean;
  confirmUploadAction: string,
  tableCode: string,
  excelCode: string,
  successNum: number,
  failNum: number,
}

const propsDef = withDefaults(defineProps<propsType>(), {
  closeDataCheck: false,
  errorList: null,
  errorMsg:'',
  errorFlag:false,
  errorDownAction: '',
  confirmUploadAction: '',
  tableCode: '',
  excelCode: '',
  successNum: 0,
  failNum: 0,
});
const {tableCode, excelCode, errorDownAction, closeDataCheck, confirmUploadAction} = toRefs(propsDef);

const closeWin = function () {
  emits('closeWin', {flush: true})
}
const showLoading = ref(false);
const successCount = ref(0);
const errorCount = ref(0);
const errorRecords: any = ref([]);
const result: any = ref({});
const resultCodeVal: any = ref('');
const uploadExcel = function () {
  showLoading.value = true;
  const queryCommand = new QueryCommand({
    url: unref(confirmUploadAction),
    method: 'POST'
  });
  queryCommand.executeQueryPromise({params: {excelCode: unref(excelCode)}}).then((res) => {
    showLoading.value = false;
    const {importResult, resultCode}: any = res;
    resultCodeVal.value = resultCode;
    if (importResult && Array.isArray(importResult)) {
      importResult.forEach((itemDb) => {
        if (itemDb.result === '导入失败') {
          errorCount.value = ++errorCount.value;
          unref(errorRecords).push(itemDb);
        } else {
          successCount.value = ++successCount.value;
        }
      })
    }
  });
}
onMounted(() => {
  if (!unref(closeDataCheck)) {
    uploadExcel();
  }
})

const downErrorTemp = function () {
  const queryCommand = new QueryCommand({showTip: false});
  queryCommand.executeExport(
    unref(errorDownAction),
    ('导入错误信息') + '.xlsx',
    {resultCode: unref(resultCodeVal)}
  );
}
</script>

<style type="text/css" lang="less">

</style>
